// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"157":"a4d3afb1","632":"1c1db90c","804":"1c1db90c","936":"1c1db90c"}[chunkId] + ".chunk.css";
};